import { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

import { getApiTokensInLocalStorage } from '../../services/localStorage/localStorage';

const ProtectedRouteLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isAuthenticated = getApiTokensInLocalStorage();

    if (!isAuthenticated) {
      const params = new URLSearchParams();
      params.set('from', location.pathname);
      navigate('/login?' + params.toString());
    }
  }, [navigate, location]);

  return <Outlet />;
};

export default ProtectedRouteLayout;
